import { render } from "./ProfileInfoSection.vue?vue&type=template&id=fba8b7a4"
const script = {}

import exportComponent from "/tmp/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__